"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArchwireType_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var ArchwireType_Factory = /** @class */ (function () {
    function ArchwireType_Factory() {
    }
    ArchwireType_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Name: model.Name,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
        };
        return result;
    };
    ArchwireType_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Name: model.Name,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
        };
        return result;
    };
    return ArchwireType_Factory;
}());
exports.ArchwireType_Factory = ArchwireType_Factory;
